module.exports = __webpack_public_path__ + "img/shopping.3b92be57.svg";